import { useCurrentSpaceView } from 'src/hooks/space';

export const usePersonalWikiId = () => {
  const spaceView = useCurrentSpaceView();
  return spaceView?.setting.wikiId;
};
